import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import ImgChild from 'src/assets/images/imgChild.svg';
import ImgInsult from 'src/assets/images/imgInsult.svg';
import ImgSexual from 'src/assets/images/imgSexual.svg';
import { pushAfterMatchPopupCancelEvent, pushAfterMatchPopupReportEvent, pushAfterMatchPopupShowEvent, type AfterMatchPopupEventParam } from 'src/components/AzarOnly/AfterMatchModal/events';
import GenericButton from 'src/components/GenericButton';
import ModalLayout, { ModalLayoutProps, MobileModalType, ModalHeader, ModalHeaderTitle, ModalHeaderDescriptionRow } from 'src/components/ModalLayout';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const IconWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 16px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({
  theme
}) => theme.screenSize.mobile} {
    max-width: none;
    margin: 0;
  }
`;
const Icon = styled.svg`
  height: 80px;
  width: 80px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  padding: 16px 24px 24px 24px;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  align-self: stretch;
`;
interface Props extends ModalLayoutProps {
  eventParams: AfterMatchPopupEventParam;
  onReport?: () => void | Promise<void>;
}
export default function AfterMatchModal({
  eventParams,
  onReport,
  onClose
}: Props) {
  const {
    t
  } = useTranslation();
  useEffect(() => {
    pushAfterMatchPopupShowEvent(eventParams);
  }, [eventParams]);
  const handleReport = async () => {
    pushAfterMatchPopupReportEvent(eventParams);
    await onReport?.();
  };
  const handleClose = () => {
    pushAfterMatchPopupCancelEvent(eventParams);
    onClose?.();
  };
  return <ModalLayout mobileType={MobileModalType.BOTTOM_SHEET} onClose={handleClose} isDim data-sentry-element="ModalLayout" data-sentry-component="AfterMatchModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalHeaderTitle mobileType={MobileModalType.BOTTOM_SHEET} data-sentry-element="ModalHeaderTitle" data-sentry-source-file="index.tsx">
          {t('after_match_popup_title')}
        </ModalHeaderTitle>
        <ModalHeaderDescriptionRow data-sentry-element="ModalHeaderDescriptionRow" data-sentry-source-file="index.tsx">{t('after_match_popup_desc')}</ModalHeaderDescriptionRow>
      </ModalHeader>
      <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <IconWrapper data-sentry-element="IconWrapper" data-sentry-source-file="index.tsx">
          <Icon as={ImgSexual} aria-label='after_match_popup_icon_sexual' data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          <Icon as={ImgInsult} aria-label='after_match_popup_icon_insult' data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          <Icon as={ImgChild} aria-label='after_match_popup_icon_child' data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        </IconWrapper>
        <ButtonWrapper data-sentry-element="ButtonWrapper" data-sentry-source-file="index.tsx">
          <GenericButton size='large' variant='primary' onClick={handleReport} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
            {t('after_match_popup_button_report')}
          </GenericButton>
          <GenericButton size='large' variant='textSecondary' onClick={handleClose} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
            {t('after_match_popup_button_next_match')}
          </GenericButton>
        </ButtonWrapper>
      </Container>
    </ModalLayout>;
}